/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Proof_Status_ValueInputs */

const en_dr_proof_status_value = /** @type {(inputs: Dr_Proof_Status_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supported`)
};

const id_dr_proof_status_value = /** @type {(inputs: Dr_Proof_Status_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terdukung`)
};

/**
* | output |
* | --- |
* | "Supported" |
*
* @param {Dr_Proof_Status_ValueInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_proof_status_value = /** @type {((inputs?: Dr_Proof_Status_ValueInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Proof_Status_ValueInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_proof_status_value(inputs)
	return en_dr_proof_status_value(inputs)
});